<template>
    <div>
        <!-- <Form
            :model="searchItem"
            :label-width="85"
            label-position="left"
            :disabled="modal_loading"
            ref="formValidate" 
            :show-message="false"
            style="margin-top:20px"
        >
            <Row style="margin-bottom: 0">
                <Col span="5">
                <FormItem label="年度">
                    <DatePicker type="year" v-model="searchItem.begindate"></DatePicker>
                </FormItem>
                </Col>
                <Col span="5" offset="1">
                <FormItem label="公司" >
                    <Select :clearable="true"  v-model="searchItem.contracttype" :disabled="false">
                        <Option v-for="item in GSList" :value="item.value" :key="item.value" :label="item.label"></Option>
                    </Select>
                </FormItem>
                </Col>
                <Col span="5" offset="1">
                <FormItem  label="部门" >
                    <Select :clearable="true"  v-model="searchItem.contracttype" :disabled="false">
                        <Option v-for="item in BMList" :value="item.value" :key="item.value" :label="item.label"></Option>
                    </Select>
                </FormItem>
                </Col>
                <Col span="1" offset="1">
                <Button type="primary" @click="getData()">查询</Button>
                </Col>
            </Row>
        </Form> -->
        <div class="chartRow">
            <PieChart></PieChart>
            <BarChart></BarChart>
        </div>
    </div>
</template>

<script>
import PieChart from '@/components/bipage/components/PieChart'
import BarChart from '@/components/bipage/components/BarChart'
export default {
    components:{
        PieChart,
        BarChart
    },
    data(){
        return{
            modal_loading:false,
            searchItem:{},
            GSList:[
                {value:'1',label:'name1'},
                {value:'2',label:'name2'},
                {value:'3',label:'name3'}
            ],
            BMList:[
                {value:'1',label:'name1'},
                {value:'2',label:'name2'},
                {value:'3',label:'name3'}
            ]
        }
    },
    mounted(){
    },
    methods:{
    }
}
</script>

<style scoped>
.ivu-input-prefix i, .ivu-input-suffix i {
    line-height: 28px !important;
}
.chartRow {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}
.chartCol {
    width: 50%;
    padding: 20px;
    box-sizing: border-box;
    border:1px solid #dcdee2
}
.chartCol:nth-child(odd) {
    border-right:0px solid #dcdee2
}
.chartCol:nth-child(1) {
    border-bottom:0px solid #dcdee2
}
.chartCol:nth-child(2) {
    border-bottom:0px solid #dcdee2
}
</style>


// WEBPACK FOOTER //
// src/components/bipage/NormalDistributionReport.vue